import { createClient } from "@jog/ct";
import { asLink, isFilled } from "@prismicio/helpers";
import { getPaths, lowerCaseEq, retry, typedBoolean } from "../helper";
import { RedisCache } from "../redis/client";
export const buildShopTheLookPage = async (client, redisItem, locale1) => {
    const uid = redisItem.deps.uid;
    if (!uid)
        throw new Error("The shop the look does not uid");
    const prismic = await retry(() => client.getByUID("coord_set_and_look", uid));
    const products = await getShopTheLookProducts(prismic, redisItem, locale1);
    return { ...redisItem, prismic, type: "shopTheLookDetail", products };
};
const getProduct = async (_url, locale, locale1 = locale) => {
    var _a, _b, _c;
    if (!isFilled.link(_url))
        return;
    const url = asLink(_url);
    if (!url)
        return;
    const redisCache = new RedisCache();
    const redisItem = await redisCache.getProductId(new URL(url).pathname.replace(/^\//, ""), locale);
    if (!redisItem)
        return;
    const ctClient = createClient();
    const res = await ctClient.product({ id: redisItem.id, locale1: locale1, locale2: locale });
    if (!(res === null || res === void 0 ? void 0 : res.product))
        return;
    return {
        id: res.product.id,
        name: ((_a = res.product.masterData.current) === null || _a === void 0 ? void 0 : _a.name) || "",
        path: ((_c = getPaths(((_b = res.product.masterData.current) === null || _b === void 0 ? void 0 : _b.masterVariant.attributesRaw) || []).find((i) => lowerCaseEq(i.locale, locale))) === null || _c === void 0 ? void 0 : _c.url) || "",
    };
};
const getShopTheLookProducts = async (prismic, redisItem, locale1) => {
    const products = (await Promise.all(prismic.data.products.map(({ product_link, cover }) => {
        if (!isFilled.image(cover))
            return;
        return getProduct(product_link, redisItem.locale, locale1).then((res) => res ? { ...res, cover } : undefined);
    }))).filter(typedBoolean);
    return products.filter((i) => (i === null || i === void 0 ? void 0 : i.id) && (i === null || i === void 0 ? void 0 : i.name));
};
